import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { StringUtils } from '../utils/stringUtils';
import { HttpClient } from '@angular/common/http';
import { NetworkServices } from './networkServices';
import { NotificationServices } from './notificationServices';
import { StorageServices } from './storageService';
import { ConfigUtils } from '../utils/configUtils';
import { ReaccionesMsg } from '../msg/regReaccionesMsg';
import { UserServices } from './userServices';
import { CatalogServices } from './catalogServices';

@Injectable()
export class BodegaServices{
  static currentSolicitudEM: any;
  public entradaMercanciaCompraSave: Subject<boolean>=new Subject<boolean>();
  
  constructor(public http: HttpClient, private userService: UserServices, private catalogService: CatalogServices){}
  getListadoBodegas(){
    let ms=[];
    let me=this.catalogService.getCatalogByName('bodegasConUbicaciones');
    if(me && me.Error){
      console.log('Error: catalogo bodegas '+me.Error);
    }else{
      me.Bodegas.forEach(bodega=>{
        ms.push({
          "name": bodega
        });
      });
    }
    return ms;
  }
  onEntradaMercanciaCompraSaved():Observable<boolean>{
    return this.entradaMercanciaCompraSave.asObservable();
  }
  getContenidoUbicacion(ubicacion){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/consultaubicacion/'+ubicacion;
    return this.http.get<any>(url).toPromise();
  }
  getPedidosByProveedor(codProveedor){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getPedidosPorProveedor/'+codProveedor;
    return this.http.get<any>(url);
  }
  getFacturasReservaPorProveedor(codProveedor){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getFacturasReservaPorProveedor/'+codProveedor;
    return this.http.get<any>(url);
  }
  getPedidosByFacturaReserva(docNum){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getPedidosPorFacturaReserva/'+docNum;
    return this.http.get<any>(url);
  }
  getEMByProveedor(codProveedor){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getEMPorProveedor/'+codProveedor;
    return this.http.get<any>(url);
  }
  getArticulosConStock(){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getArticulosConStock';
    return this.http.get<any>(url);
  }
  getLotesConStockByCodArticulo(codArticulo){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getLotesConStockByCodArticulo/'+codArticulo;
    console.log(url);
    return this.http.get<any>(url);
  }
  getDetalleLotePesaje(param){
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getDetalleLoteEnPesaje';
    console.log(url);
    return this.http.post<any>(url,param);
  }
  guardarEntradaMercanciaPorCompra(documento){
    if(this.userService.currentUser && this.userService.currentUser.UserName)
      documento.responsable=this.userService.currentUser.UserName;
    let url = ConfigUtils.getUrlFromEndPointName('entradaMercanciaCompra');
    return this.http.post<any>(url,documento)
  }
  getUbicacionesYDetArticuloPorLote(loteYcodArticulo){
    //V2403330&codArticulo=80000343
    console.log(loteYcodArticulo);
    
    var lote = loteYcodArticulo;
    var codArticulo=null;
    var matrix = loteYcodArticulo.split('&');
    console.log(matrix);
    console.log(matrix.length); 
    if(matrix && matrix.length==2){// adicional al lote se pasa como parámetro el código del artículo
      lote=matrix[0];
      console.log(lote);
      codArticulo=matrix[1];
      codArticulo=codArticulo.replace('codArticulo=','');
      console.log(codArticulo);
    }
    
    let url = ConfigUtils.getUrlFromEndPointName('bodega');
    url+='/getUbicacionesYDetArticuloPorLote/'+lote;
    if(codArticulo)
      url+='/'+codArticulo;
    console.log(url);
    return this.http.get<any>(url);
  }
  transferirEntreUbicaciones(me){
    let url = ConfigUtils.getUrlFromEndPointName('transferenciaStock');
    console.log(url);
    console.log(me);
    return this.http.post<any>(url,me)
  }
  transferirFromST(me){
    let url = ConfigUtils.getUrlFromEndPointName('tsFromST');
    return this.http.post<any>(url,me)
  }
  transferFromPesajeToMat(me){
    let url = ConfigUtils.getUrlFromEndPointName('tsFromPesajeToMat');
    return this.http.post<any>(url,me)
  }
}


